"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var HashUtils_1 = require("../Utils/HashUtils");
var StringUtils_1 = require("../Utils/StringUtils");
var XoneDataObject_1 = require("./XoneDataObject");
var XoneUser = /** @class */ (function (_super) {
    __extends(XoneUser, _super);
    /**
     * Construye un objeto de datos que representa un usuario de aplicación.
     *
     * @param OwnerCollection Colección propietaria de este objeto.
     */
    function XoneUser(OwnerCollection) {
        var _this = _super.call(this, OwnerCollection) || this;
        // A11042901: Modificaciones para adicionar nuevos algoritmos de comprobación de claves.
        // Obtener el modelo de hash que lleva el campo que nos interesa
        try {
            _this.m_strHashType = OwnerCollection.FieldPropertyValue("PWD", "hash-type");
            // K13022601: Modificaciones en el manejo de claves de usuario usando hash.
            // El encoding
            if (StringUtils_1.default.IsEmptyString(_this.m_strEncode = OwnerCollection.FieldPropertyValue("PWD", "encode"))) {
                // Por defecto base64
                _this.m_strEncode = "base64";
            }
        }
        catch (ex) {
            throw ex;
        }
        return _this;
    }
    XoneUser.prototype.ValidateUserCredentials = function (UserData) {
        // Aquí solamente esperamos un parámetro que será la clave o el hash
        var strPwd = StringUtils_1.default.SafeToString(UserData[0]);
        var strObjPwd = StringUtils_1.default.SafeToString(this.get("PWD"));
        if (StringUtils_1.default.IsEmptyString(strPwd)) {
            // Clave vacía
            return StringUtils_1.default.IsEmptyString(strObjPwd);
        }
        // A11042901: Modificaciones para adicionar nuevos algoritmos de comprobación de claves.
        if (!StringUtils_1.default.IsEmptyString(this.m_strHashType)) {
            /*
             * K13022601: Modificaciones en el manejo de claves de usuario usando hash. El atributo
             * hash-type y encode debe ser case insensitive
             */
            strPwd = HashUtils_1.default.createHash(this.m_strHashType, this.m_strEncode, strPwd);
            // this.MessageDigest md = this.getMessageDigest(this.m_strHashType);
            // if (md != null) {
            //     byte[] source = new byte[strPwd.length()];
            //     StringUtils.CopyAsBytes(strPwd, source, 0);
            //     md.update(source);
            //     byte[] btmp = md.digest();
            //     strPwd = StringUtils.encodeHash(btmp, this.m_strEncode);
            // }
        }
        // Ahora comparamos... clave con clave o hash con hash... lo que sea...
        return strObjPwd.equals(strPwd);
    };
    return XoneUser;
}(XoneDataObject_1.XoneDataObject));
exports.default = XoneUser;

//# sourceMappingURL=XoneUser.js.map
